function Pillar() {
    return (<div className={"pillar"}>
    </div>)


} export default Pillar;